<template>
    <div class="mainPage">
        <ztHeader>
            <div slot="logincon" class="loginWrapper">
                <div v-if="!isLogin">
                    <span @click="toLogin()">{{ $t('message.login') }}</span> | 
                    <span @click="toLogin()">{{ $t('message.register') }}</span>
                </div>
                <div v-if="isLogin">
                    <span><span>{{user.username}}</span><span @click="toLogOut()">{{ $t('message.logout') }}</span> </span>
                </div>
            </div>
        </ztHeader>
        <div class="mainContent">

        </div>
        <pcfooter></pcfooter>
        <!-- 播放视频 -->
        <div id="videoPlayWrapper" v-show="isShowVideo">
            <div class="videoContent">
                <div class="closeVideo" @click="closeVideo()">×</div>
                <div class="videoContainer"><video :src="currentVideoUrl" id="liveVideo" controls></video></div>
            </div>
        </div>
    </div>
</template>

<script>
import ztHeader from './ztHeader'
import pcfooter from './footer'
export default { 
    name: 'africa_teacher_classlive',
    components: {
        ztHeader,
        pcfooter
    },
    data: function () {
        return {
            isShowVideo: false,
            currentVideoUrl:'',
            isLogin: false,
            user: {
                username: '',
                email: ''
            }
        }
    },
    methods: {
        tolive (url) {
            window.open(url)
        },
        showCurrent (url,filename,type) {
            if(type == 'video'){
                this.isShowVideo = true
                this.currentVideoUrl = url
            }else {
                var link = document.createElement('a');
                //设置下载的文件名
                link.download = filename;
                link.style.display = 'none';
                //设置下载路径
                link.href = url;
                //触发点击
                document.body.appendChild(link);
                link.click();
                //移除节点
                document.body.removeChild(link);
            }
            
        },
        toHref (href) {
            window.open(href)
        },
        closeVideo () {
            this.isShowVideo = false
            var myvideo = document.getElementById('liveVideo');
            if (!myvideo.paused) {
                myvideo.pause();
            }
        },
        toLogin() {
            window.location.href =
            this.baseUrl +
            "user/api/login?" +
            "callback=" +
            encodeURIComponent(window.location.href);
        },
        toRegister() {
            window.location.href = 'https://passport.chinesecio.com/static/frontend/dist/#/pc/register?callback=' + encodeURIComponent(window.location.href);
        },
        customCheckLogin() {
            this.checkLogin().then(res => {
                if(res.data.success){
                    this.isLogin = true
                    this.user = res.data.data
                } else {
                    this.isLogin = false
                }
            })
        },
        toLogOut() {
            this.$utils.get('/user/api/logout').then(res => {
                if(res.data.success) {
                    this.isLogin = false
                }
            })
        },
        getCommentList() {
            
        }
        
    },
    mounted() {
        this.customCheckLogin()
    }


}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.mainPage {
    text-align: center;
    position: relative;
    .loginWrapper {
        font-size: 16px;
        color: #fff;
        display: inline-block;
        margin-left: 20px;
        cursor: pointer;
        span {
            margin: 0 5px;
            cursor: pointer;
        }
    }
    .topBg {
        width: 100%;
    }
    .mainContent {
        min-height: 1000px;
    }
    #videoPlayWrapper {
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background-color: rgba(0, 0, 0, 0.8);
        z-index: 999;
        }
        #videoPlayWrapper .closeVideo {
        position: absolute;
        right: 20px;
        top: 10px;
        font-size: 50px;
        color: #fff;
        cursor: pointer;
        }
        .videoContent {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        }
        .videoContainer {
        text-align: center;
        width: 100%;
        }
        .videoContainer video {
        width: 62%;
    }
}

</style>
